module.exports = __webpack_public_path__ + "static/img/14.3a455ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/zh/14.png
// module id = 3oUW
// module chunks = 0